//
//
//
//
//

export default {
  props: {
    showmessageurl: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      openurl: 'http://lc-ie.hexasino.com/instDetail?instId=4&discussionMessage=0'
    };
  },
  methods: {},
  created: function created() {
    //   this
    //   this.downurl = this.downurl + this.pwd.split('//')[2];
    //   console.log(this.downurl,"saddsdsadasdas")
    //   this.$refs.downfile.contentWindow.postMessage({data:url})
  },
  mounted: function mounted() {}
};